<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="location_id detail_content">
            <div class="location_id_label detail_label">
              {{ locationIdLabel }}
            </div>
            {{ beacon.locationId }}
          </div>
          <div class="location_name detail_content">
            <div class="location_name_label detail_label">
              {{ locationNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="beacon.locationName"
              @input="inputUpdate('locationName')"
            />
          </div>
          <div class="uuid detail_content">
            <div class="uuid_label detail_label">
              {{ uuidLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="beacon.uuid"
              @input="inputUpdate('uuid')"
            />
          </div>
          <div class="major detail_content">
            <div class="major_label detail_label">
              {{ majorLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="beacon.major"
              @input="inputUpdate('major')"
            />
          </div>
          <div class="minor detail_content">
            <div class="minor_label detail_label">
              {{ minorLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="beacon.minor"
              @input="inputUpdate('minor')"
            />
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showModal = true"
        />
      </div>
      <div class="modal_window" v-if="showModal">
        <modalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </modalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import modalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      locationIdLabel: 'ビーコンID',
      locationNameLabel: '場所名',
      uuidLabel: 'UUID',
      majorLabel: 'メジャー値',
      minorLabel: 'マイナー値',
      router: '/beacons',
      deleteWord: 'この情報を削除してよろしいですか？',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    beacon() {
      return this.$store.state.beacons.beacon
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  components: {
    modalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('beacons/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'beacons/setDetailBeacon',
          this.$store.state.beacons.beacon
        )
        this.$router.push('../beacons/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_410001
        let eventType = 3
        let reason = 'MSGCRC0081 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0081.name +
            this.errorMsg.MSGCRC0081.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('beacons/updateBeacon')
        this.$router.push('../beacons/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_410003
        let eventType = 3
        let reason = ''
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0077') {
              this.failureWord =
                this.errorMsg.MSGCRC0077.name +
                this.errorMsg.MSGCRC0077.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0078') {
              this.failureWord =
                this.errorMsg.MSGCRC0078.name +
                this.errorMsg.MSGCRC0078.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0113') {
              this.failureWord =
                this.errorMsg.MSGCRC0113.name +
                this.errorMsg.MSGCRC0113.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0114') {
              this.failureWord =
                this.errorMsg.MSGCRC0114.name +
                this.errorMsg.MSGCRC0114.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0116') {
              this.failureWord =
                this.errorMsg.MSGCRC0116.name +
                this.errorMsg.MSGCRC0116.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0117') {
              this.failureWord =
                this.errorMsg.MSGCRC0117.name +
                this.errorMsg.MSGCRC0117.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0082.name +
                this.errorMsg.MSGCRC0082.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            if (error.response.data['data[0].beacons[0].major']) {
              this.failureWord =
                this.errorMsg.MSGCRC0119.name +
                this.errorMsg.MSGCRC0119.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0119'
            } else if (error.response.data['data[0].beacons[0].minor']) {
              this.failureWord =
                this.errorMsg.MSGCRC0120.name +
                this.errorMsg.MSGCRC0120.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0120'
            } else {
              // this route isn't used.
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'beacons/setDetailBeacon',
          this.$store.state.beacons.beacon
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_410002
        let eventType = 3
        let reason = 'MSGCRC0081'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0081.name +
            this.errorMsg.MSGCRC0081.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let locationId = this.$store.state.beacons.beacon.locationId
      let deleteList = [{locationId}]
      try {
        await this.$store.dispatch('beacons/deleteBeacons', deleteList)
        this.showModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_410004
        let eventType = 3
        let reason = 'MSGCRC0083 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0083.name +
            this.errorMsg.MSGCRC0083.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/beacons/beaconEdit.vue